import { api } from '../slices/api.ts';
import { UserListInterface } from '../../interfaces/User.interface.ts';

export interface UserQueryInterface {
	page?: number;
	search?: string;
	ordering?: string;
	groups__name?: string;
	is_active?: boolean;
}

export interface ResolveOperatorPinRequest {
	pin: string;
	// Only for the emergency fallback: the operator picked explicitly when a
	// normal PIN is unavailable.
	operator_user_id?: number | string;
	// Role group(s) the calling screen records. When set, the server refuses a
	// PIN whose operator is outside this role (and narrows the emergency
	// selector to it), keeping each screen's per-role attribution.
	expected_groups?: string[];
}

export interface ResolveOperatorPinResponse {
	user_id: number;
	full_name: string;
	emergency_used: boolean;
	must_rotate_pin: boolean;
}

export const extendedApiSlice = api.injectEndpoints({
	endpoints: (builder) => ({
		getUsers: builder.query<
			{ count: number; results: UserListInterface[] },
			UserQueryInterface
		>({
			query: (params) => {
				const merged = { is_active: true, ...params };
				const queryParams = new URLSearchParams();
				Object.entries(merged).forEach(([key, value]) => {
					if (value !== undefined) {
						queryParams.append(key, value.toString());
					}
				});
				if (queryParams.toString() === '') {
					return 'users/';
				}
				return `users/?${queryParams.toString()}`;
			},
		}),
		getLoggedInUser: builder.query<UserListInterface, void>({
			query: () => 'users/logged_in_user/',
		}),
		resolveOperatorPin: builder.mutation<
			ResolveOperatorPinResponse,
			ResolveOperatorPinRequest
		>({
			query: (body) => ({
				url: 'floor/operator-pins/resolve/',
				method: 'POST',
				body,
			}),
		}),
	}),
});

export const {
	useGetUsersQuery,
	useGetLoggedInUserQuery,
	useResolveOperatorPinMutation,
} = extendedApiSlice;
